import { FC } from 'react'

import { logisticApi } from 'redux/services/logistic'
import { LogisticShortObject } from 'redux/services/logistic/types'

import { AppButton } from 'components/AppButton'

interface Props {
  logisticCart: LogisticShortObject
  setSelectedRow: (logisticCart: LogisticShortObject) => void
}

export const EditLogisticCell: FC<Props> = props => {
  const { logisticCart, setSelectedRow } = props
  const { data: logisticCartForEdit } =
    logisticApi.endpoints.getLogisticCartForEdit.useQueryState({
      id: logisticCart.id,
    })

  return (
    <AppButton
      size="small"
      disabled={!logisticCartForEdit}
      onClick={() => setSelectedRow(logisticCart)}
    >
      На доставку
    </AppButton>
  )
}
